import { render, staticRenderFns } from "./HeadersDialog.vue?vue&type=template&id=09887d88"
import script from "./HeadersDialog.vue?vue&type=script&lang=js"
export * from "./HeadersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports